export default "__VITE_ASSET__C1wRuuI7__"